<!------------------------------------------------------------------------------
  Copyright (c) 2018. keni

  This file list-provided-search.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  list-provided-search.vue can not be copied and/or distributed
  without the express permission of keni
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: list-provided-search 
 Created by keni.
 with: IntelliJ IDEA
 Date: 17/09/2018
 Time: 11:31
------------------------------------------------------------------------------->
<template>
    <div class=" d-flex justify-content-between align-items-center ">
        <input type="search"
                ref="search"
                title="search--input"
                class=" py-0 px-1"
                :class="setInputClass()"
                v-model="searchString"
                @input="onInput()"
        >

        <i v-if="!this.isActive" class="ml-3 float-right d-block material-icons fs-5 cursor-pointer w-10-i watch-transition--fast"
                :class="icon_class"
                aria-hidden="true"
                v-on:click="activateSearch($event)"
        >search</i>
        <i v-else class="ml-3 float-right d-block material-icons fs-5 cursor-pointer w-10-i watch-transition--fast"
                :class="icon_class"
                aria-hidden="true"
                v-on:click="activateSearch($event)"
        >close</i>
    </div>
</template>

<script>
	export default {
		name: "",
		components: {},

		props: {
			icon_class:{
				type:String,
                default:''
            },
			search_:{
				type:String
            },
			expanded_class:{
				type:String,
                default:''
			}
        },
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {
				default_cls:{
					expanded:'w-80-i bg-white'
                },
				ref_id:_.uniqueId(),
				searchString: '',
				isActive: false
			}
		},
		methods: {
			onInput(e) {
// console.log('onInput', 'e',e);
				this.$emit('search_', this.searchString.trim());
			},
			activateSearch() {
				this.isActive = !this.isActive;
				this.$emit('search_', null);
				if(!this.isActive){
					this.searchString = '';
					this.$emit('search_active_', false);
                }else{
					// let id = this.ref_id;
					// console.log('activateSearch',this.$refs.search.$el);
					this.$refs.search.focus();
					this.$emit('search_active_', true);
                }
			},
			setInputClass() {
				let activeClass = 'w-0-i';

				if (this.isActive) {

					activeClass = (this.expanded_class!=='')?this.expanded_class: this.default_cls.expanded;
				}
				return `${activeClass} border-bottom-0 `;
			},
		},
		watch: {},
		computed: {
			// searchString(text){
			// 	console.log('searchString', 'text',text);
			// }
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/search/list-provided-search.vue